import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n\n  @media (max-width: 768px) {\n    position: relative;\n    padding: 8px 0px;\n  }\n\n  .detail-content {\n    padding-top: 48px;\n    display: flex;\n    flex-direction: column;\n    div:first-child > .ant-divider {\n      display: none;\n    }\n    @media (max-width: 768px) {\n      padding-top: 32px;\n    }\n  }\n\n  .studio-promotion-image {\n    margin-top: 44px;\n\n    &.m {\n      display: none;\n    }\n\n    @media (max-width: 768px) {\n      &.w {\n        display: none;\n      }\n\n      &.m {\n        display: block;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  position: sticky;\n  top: 0px;\n  background-color: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  align-items: center;\n  justify-content: flex-start;\n  cursor: pointer;\n  font-weight: 600;\n  color: ",
        ";\n  transition: top 0.2s ease-in-out;\n  z-index: 1;\n\n  li {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-grow: 1;\n\n    a {\n      width: 100%;\n      font-size: 16px;\n      padding: 16px 0px;\n      line-height: 1.5;\n      text-align: center;\n      color: ",
        ";\n\n      &.active {\n        padding: 16px 10px 14px;\n        border-bottom: 2px solid ",
        ";\n        color: ",
        ";\n      }\n    }\n  }\n\n  @media (max-width: 1200px) {\n  }\n  @media (max-width: 768px) {\n    font-size: 14px;\n    li a {\n      padding: 12px 9px;\n      &.active {\n        padding: 12px 5px 10px;\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  &:nth-of-type(1) {\n    padding-top: 0;\n  }\n\n  border-radius: 6px;\n  //padding-top: 72px;\n\n  > h3 {\n    font-size: 20px;\n    margin-bottom: 16px;\n    font-weight: 700;\n  }\n\n  .wrapper {\n    border-radius: 6px;\n    background-color: ",
        ";\n    padding: 20px;\n    color: ",
        ";\n    white-space: pre-wrap;\n    span {\n      line-height: 1.5;\n    }\n\n    > :first-child.title {\n      margin-bottom: 8px;\n    }\n    .title {\n      font-weight: 700;\n    }\n  }\n\n  @media (max-width: 768px) {\n    > h3 {\n      font-size: 16px;\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  div {\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n  }\n\n  img {\n    border-radius: 6px;\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n  .description {\n    margin-bottom: 16px;\n    line-height: 1.5;\n    margin-top: 12px;\n  }\n  ul {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    gap: 16px;\n\n    li {\n      width: calc(50% - 20px);\n      /* display: flex; */\n      display: grid;\n      grid-template-columns: 100px auto;\n\n      span {\n        display: inline-block;\n        line-height: 1.5;\n      }\n\n      span.title {\n        width: 100px;\n      }\n\n      span.content {\n        width: calc(100% - 100px);\n        color: ",
        ";\n      }\n    }\n  }\n\n  @media (max-width: 768px) {\n    ul {\n      flex-direction: column;\n\n      li {\n        width: 100%;\n      }\n    }\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _tagged_template_literal([
        "\n  .info-cell {\n    display: flex;\n    gap: 16px;\n\n    margin-top: 32px;\n\n    @media screen and (max-width: 768px) {\n      flex-direction: column;\n    }\n\n    .title {\n      min-width: 100px;\n      font-weight: 600;\n    }\n\n    .content {\n      color: ",
        ";\n      flex-grow: 1;\n      line-height: 1.5;\n      white-space: break-spaces;\n      > p {\n        line-height: 1.5;\n        color: ",
        ";\n      }\n\n      text-align: justify;\n    }\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _tagged_template_literal([
        "\n  .content {\n    line-height: 1.5;\n    color: ",
        ";\n  }\n\n  .wrapper:not(:last-of-type) {\n    margin-bottom: 24px;\n  }\n\n  ul > li {\n    color: ",
        ";\n    list-style-type: disc;\n    margin-inline-start: 24px;\n  }\n\n  ol {\n    padding: 0;\n    margin-bottom: 0;\n  }\n  ol > li {\n    color: ",
        ";\n    list-style-type: decimal;\n    margin-inline-start: 24px;\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _tagged_template_literal([
        "\n  position: sticky;\n  top: 112px;\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _tagged_template_literal([
        "\n  span:first-child {\n    margin-right: 16px;\n  }\n\n  > div {\n    margin-top: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  div {\n    color: ",
        ";\n  }\n\n  @media (max-width: 768px) {\n    span {\n      font-size: 14px;\n    }\n\n    span:first-child {\n      margin-right: 12px;\n    }\n  }\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = _tagged_template_literal([
        "\n  margin: 24px 0;\n  .ant-divider {\n    color: ",
        ";\n  }\n  @media (max-width: 768px) {\n    margin: 24px 0;\n  }\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = _tagged_template_literal([
        "\n  .product-price {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 32px; /* 133.333% */\n  }\n\n  .sub-text {\n    color: ",
        ";\n    //text-align: center;\n    font-size: 14px;\n    line-height: 22px; /* 157.143% */\n    letter-spacing: -0.14px;\n    margin-top: 4px;\n    font-weight: 600;\n  }\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n\n  .discount-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n\n    p {\n      color: ",
        ";\n      &:nth-of-type(2) {\n        font-weight: 600;\n      }\n    }\n  }\n  button {\n    all: unset;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n    padding: 5px 12px;\n    font-size: 14px;\n    font-weight: 600;\n    background-color: ",
        ";\n\n    :hover {\n      background-color: ",
        ";\n    }\n    span {\n      color: ",
        ";\n    }\n\n    div {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n    }\n    cursor: pointer;\n    &.show-coupon {\n      background-color: ",
        ";\n      border: 1px solid ",
        ";\n\n      :hover {\n        background-color: ",
        ";\n      }\n      span {\n        color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
import { Divider } from "antd";
import { Element } from "react-scroll";
import styled from "styled-components";
const ProductDetailContentWrapper = styled.div.withConfig({
    componentId: "sc-686cbc7e-0"
})(_templateObject());
const StyledAnchor = styled.ul.withConfig({
    componentId: "sc-686cbc7e-1"
})(_templateObject1(), (props)=>props.theme.new.colors.white, (props)=>props.theme.new.colors.sol_gray_50, (props)=>props.theme.new.colors.sol_gray_400, (props)=>props.theme.new.colors.sol_gray_400, (props)=>props.theme.new.colors.sol_gray_700, (props)=>props.theme.new.colors.sol_gray_700);
const ContentWrapper = styled(Element).withConfig({
    componentId: "sc-686cbc7e-2"
})(_templateObject2(), (props)=>props.theme.new.colors.sol_gray_0, (props)=>props.theme.new.colors.sol_gray_600);
const PreviewTab = styled(ContentWrapper).withConfig({
    componentId: "sc-686cbc7e-3"
})(_templateObject3(), (props)=>props.theme.new.colors.sol_gray_100);
const DetailTab = styled(ContentWrapper).withConfig({
    componentId: "sc-686cbc7e-4"
})(_templateObject4(), (props)=>props.theme.new.colors.sol_gray_600);
const BookInfoTab = styled(ContentWrapper).withConfig({
    componentId: "sc-686cbc7e-5"
})(_templateObject5(), (props)=>props.theme.new.colors.sol_gray_600, (props)=>props.theme.new.colors.sol_gray_600);
const RefundTab = styled(ContentWrapper).withConfig({
    componentId: "sc-686cbc7e-6"
})(_templateObject6(), (props)=>props.theme.new.colors.sol_gray_600, (props)=>props.theme.new.colors.sol_gray_600, (props)=>props.theme.new.colors.sol_gray_600);
const PriceTab = styled.div.withConfig({
    componentId: "sc-686cbc7e-7"
})(_templateObject7());
const ContentsTab = styled(ContentWrapper).withConfig({
    componentId: "sc-686cbc7e-8"
})(_templateObject8(), (props)=>props.theme.new.colors.sol_gray_600);
const StyledDivider = styled(Divider).withConfig({
    componentId: "sc-686cbc7e-9"
})(_templateObject9(), (props)=>props.theme.new.colors.sol_gray_50);
const PriceSection = styled.div.withConfig({
    componentId: "sc-686cbc7e-10"
})(_templateObject10(), (props)=>props.theme.new.colors.sol_blue_500);
const CouponInfoBox = styled.div.withConfig({
    componentId: "sc-686cbc7e-11"
})(_templateObject11(), (props)=>props.theme.new.colors.sol_red_400, (props)=>props.theme.new.colors.sol_red_0, (props)=>props.theme.new.colors.sol_red_500, (props)=>props.theme.new.colors.sol_red_400, (props)=>props.theme.new.colors.white, (props)=>props.theme.new.colors.sol_gray_200, (props)=>props.theme.new.colors.sol_dim_gray, (props)=>props.theme.new.colors.sol_gray_500);
export { BookInfoTab, ContentsTab, ContentWrapper, CouponInfoBox, DetailTab, PreviewTab, PriceSection, PriceTab, ProductDetailContentWrapper, RefundTab, StyledAnchor, StyledDivider,  };
